// @flow
import React from 'react';
import { ArticleListCard, ArticlePlusListCard } from './ArticleListCard';
import { ArticleFeedCard } from './ArticleFeedCard';
import { ReviewListCard } from './ReviewListCard';
import { QuestionListCard } from './QuestionListCard';
import { AnswerListCard } from './AnswerListCard';

type ContentType =
  | 'article'
  | 'article-simple'
  | 'article-feed'
  | 'article-plus'
  | 'article-plus-b'
  | 'review'
  | 'question'
  | 'answer';

type Props = {
  entity: Object,
  type: ContentType,
  onSubscribe: Function,
  userSubscriptions: Object,
  nowTs?: number | null,
  imageLoading?: 'lazy' | 'eager',
  imageFetchPriority?: 'high' | 'low' | 'auto',
  userLikes: Object,
  withTags?: boolean,
  withAuthor?: boolean,
  withText?: boolean,
  withDate?: boolean,
  disableMoveImage?: boolean,
  profileAuthor?: Object,
  noMarginTop?: boolean,
  noBorderTop?: boolean,
  imageHD?: boolean
};

export class ContentListCard extends React.Component<Props> {
  render() {
    const {
      entity,
      type,
      onSubscribe,
      userSubscriptions,
      userLikes,
      withTags = true,
      withAuthor = true,
      withText = false,
      withDate = true,
      profileAuthor = null,
      noMarginTop = false,
      noBorderTop = false,
      imageHD = false
    } = this.props;

    switch (type) {
      case 'article':
        return (
          <ArticleListCard
            article={entity}
            onSubscribe={onSubscribe}
            userSubscriptions={userSubscriptions}
            userLikes={userLikes}
            withTags={withTags}
            withAuthor={withAuthor}
            withText={withText}
            withDate={withDate}
            disableMoveImage={this.props.disableMoveImage}
          />
        );

      case 'article-simple':
        return (
          <ArticleListCard
            simple
            article={entity}
            onSubscribe={onSubscribe}
            userSubscriptions={userSubscriptions}
            userLikes={userLikes}
            withTags={withTags}
            withAuthor={withAuthor}
            withText={withText}
            withDate={withDate}
            disableMoveImage={this.props.disableMoveImage}
          />
        );

      case 'article-feed':
        return (
          <ArticleFeedCard
            article={entity}
            userSubscriptions={userSubscriptions}
            withAuthor={withAuthor}
            nowTs={this.props.nowTs}
            imageLoading={this.props.imageLoading}
            imageFetchPriority={this.props.imageFetchPriority}
          />
        );

      case 'article-plus':
        return (
          <ArticlePlusListCard
            variant="a"
            article={entity}
            onSubscribe={onSubscribe}
            userSubscriptions={userSubscriptions}
            userLikes={userLikes}
            withAuthor={withAuthor}
            withText={withText}
            noMarginTop={noMarginTop}
            noBorderTop={noBorderTop}
            imageHD={imageHD}
          />
        );

      case 'article-plus-b':
        return (
          <ArticlePlusListCard
            variant="b"
            article={entity}
            onSubscribe={onSubscribe}
            userSubscriptions={userSubscriptions}
            userLikes={userLikes}
            withAuthor={withAuthor}
            withText={withText}
            noMarginTop={noMarginTop}
            noBorderTop={noBorderTop}
            imageHD={imageHD}
          />
        );

      case 'review':
        return (
          <ReviewListCard review={entity} onSubscribe={onSubscribe} userLikes={userLikes} withAuthor={withAuthor} />
        );

      case 'answer':
        return <AnswerListCard answer={entity} profileAuthor={profileAuthor} />;

      case 'question':
        return (
          <QuestionListCard
            question={entity}
            onSubscribe={onSubscribe}
            userSubscriptions={userSubscriptions}
            userLikes={userLikes}
          />
        );

      default:
        return null;
    }
  }
}
